var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKycInfoIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14885_39035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6667C4.31792 14.6667 1.33325 11.682 1.33325 7.99999C1.33325 4.31799 4.31792 1.33333 7.99992 1.33333C11.6819 1.33333 14.6666 4.31799 14.6666 7.99999C14.6666 11.682 11.6819 14.6667 7.99992 14.6667ZM7.99992 13.3333C9.41441 13.3333 10.771 12.7714 11.7712 11.7712C12.7713 10.771 13.3333 9.41448 13.3333 7.99999C13.3333 6.58551 12.7713 5.22895 11.7712 4.22876C10.771 3.22856 9.41441 2.66666 7.99992 2.66666C6.58543 2.66666 5.22888 3.22856 4.22868 4.22876C3.22849 5.22895 2.66659 6.58551 2.66659 7.99999C2.66659 9.41448 3.22849 10.771 4.22868 11.7712C5.22888 12.7714 6.58543 13.3333 7.99992 13.3333ZM4.66658 7.99999H5.99992C5.99992 8.53043 6.21063 9.03914 6.5857 9.41421C6.96078 9.78928 7.46949 9.99999 7.99992 9.99999C8.53035 9.99999 9.03906 9.78928 9.41413 9.41421C9.7892 9.03914 9.99992 8.53043 9.99992 7.99999H11.3333C11.3333 8.88405 10.9821 9.7319 10.3569 10.357C9.73182 10.9821 8.88397 11.3333 7.99992 11.3333C7.11586 11.3333 6.26802 10.9821 5.6429 10.357C5.01777 9.7319 4.66658 8.88405 4.66658 7.99999Z",
    fill: "#84858D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14885_39035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycInfoIc);
export default __webpack_public_path__ + "static/media/kyc-info-ic.ba2ec3a9ece93fab71ac79c65a0acbdc.svg";
export { ForwardRef as ReactComponent };